const subUsersValidationIT = {
    "add": {
        "first_name": {
            "required": "Il nome è obbligatorio"
        },
        "last_name": {
            "required": "Il cognome è obbligatorio"
        },
        "email": {
            "required": "L'email è obbligatoria",
            "invalid": "L'email non è valida",
            "unique": "L'email è associata a un altro utente"
        },
        "username": {
            "required": "Il nome utente è obbligatorio",
            "stringCaseLower": "Il nome utente deve essere in minuscolo",
            "regexp": "Il nome utente deve contenere solo lettere e numeri",
            "unique": "Il nome utente è associato a un altro utente",
            "invalid": "Il nome utente non è valido"
        },
        "password": {
            "required": "La password è obbligatoria",
            "regexp": "La password deve contenere almeno 10 caratteri, inclusi 1 lettera maiuscola e 1 carattere speciale"
        },
        "confirmPassword": {
            "required": "Per favore conferma la password",
            "identical": "La password e la conferma devono corrispondere"
        },
        "contract_expiry": {
            "required": "La data di scadenza del contratto è obbligatoria"
        },
        "sub_user_deal": {
            "required": "L'accordo per il subutente è obbligatorio",
            "between": "L'accordo per il subutente deve essere tra 0 e 100"
        },
        "street_and_number": {
            "required": "La via e il numero civico sono obbligatori"
        },
        "postal_code": {
            "required": "Il codice postale è obbligatorio"
        },
        "city": {
            "required": "La città è obbligatoria"
        },
        "country": {
            "required": "Il paese è obbligatorio"
        },
        "phone": {
            "required": "Il numero di telefono è obbligatorio"
        }
    },
    "update": {
        "first_name": {
            "required": "Il nome è obbligatorio"
        },
        "last_name": {
            "required": "Il cognome è obbligatorio"
        },
        "email": {
            "required": "L'email è obbligatoria",
            "invalid": "L'email non è valida"
        },
        "username": {
            "required": "Il nome utente è obbligatorio",
            "stringCaseLower": "Il nome utente deve essere in minuscolo",
            "regexp": "Il nome utente deve contenere solo lettere e numeri"
        },
        "contract_expiry": {
            "required": "La data di scadenza del contratto è obbligatoria"
        },
        "sub_user_deal": {
            "required": "L'accordo per il subutente è obbligatorio",
            "between": "L'accordo per il subutente deve essere tra 0 e 100"
        },
        "street_and_number": {
            "required": "La via e il numero civico sono obbligatori"
        },
        "postal_code": {
            "required": "Il codice postale è obbligatorio"
        },
        "city": {
            "required": "La città è obbligatoria"
        },
        "country": {
            "required": "Il paese è obbligatorio"
        },
        "phone": {
            "required": "Il numero di telefono è obbligatorio"
        }
    }
};

export default subUsersValidationIT;